import type { FC, Ref, MouseEvent } from "react";
import React from "react";
import classnames from "classnames";
import { Loader } from "../Loader/Loader";
import { MagnifierIcon } from "../../../../static/icons/MagnifierIcon";
import styles from "./SearchForm.module.scss";

interface ISearchFormProps {
  isLoading: boolean;
  isError: boolean;
  onFocus: () => void;
  onChange: (value: string) => void;
  onClick: () => void;
  onSubmit: (event: MouseEvent<HTMLFormElement>) => void;
  inputRef: Ref<HTMLInputElement>;
  value: string;
  placeholder: string;
}

/* форма поиска для десктопа */
export const SearchForm: FC<ISearchFormProps> = ({
  isLoading,
  isError,
  onFocus,
  onChange,
  onClick,
  onSubmit,
  inputRef,
  value,
  placeholder,
}) => {
  return (
    <form
      action="/search/"
      method="get"
      autoComplete="off"
      onSubmit={onSubmit}
      data-testid="header__search-form--desktop"
    >
      <div className={styles.wrapper}>
        <input
          className={classnames(styles.input, {
            [styles.error]: isError,
          })}
          maxLength={150}
          placeholder={placeholder}
          onChange={({ target: { value } }): void => {
            onChange(value);
          }}
          onClick={onClick}
          onFocus={onFocus}
          ref={inputRef}
          name="q"
          value={value}
          data-testid="search__input"
        />

        <button
          className={classnames(styles.button, {
            [styles.errorButton]: isError,
            [styles.loader]: isLoading,
          })}
          type="submit"
          data-testid="search__button"
        >
          {isLoading ? <Loader /> : <MagnifierIcon />}
        </button>
      </div>
    </form>
  );
};
